import { TitleCard } from "@/layouts/styles/ssr.style";
import { themeColor } from "@/redux/reducers/theme.reducer";
import { definitions } from "@/services/metruyenvl";
import React from "react";
import { useSelector } from "react-redux";

function PaymentCandiesTab({ user }: { user: definitions["do.UserDO"] }) {
    return (
        <div>
            <div className="w-full pb-4">
                <TitleCard>Mua kẹo</TitleCard>
            </div>
            <div className="pt-4 pb-6 pl-10 bg-orange-100 rounded-md">
                <TitleCard>Vui lòng đọc kĩ nội dung trước khi mua:</TitleCard>
                <ul className="list-disc">
                    <li>Một khi đã mua Kẹo, sẽ không được hoàn lại vì bất cứ lý do nào</li>
                    <li>Kẹo chỉ được cộng cho bạn khi nào chúng tôi chắc chắn rằng đã nhận được thanh toán của bạn</li>
                </ul>
            </div>
        </div>
    );
}

export default PaymentCandiesTab;
